import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CompanySubset } from 'app/api/company.api.service';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { CompaniesSelectors } from 'app/main/company/selectors';
import { CompaniesActions } from 'app/main/company/actions';
import { MatDialog } from '@angular/material';
import { FileUploadDialogComponent } from 'app/main/file-upload/file-upload-dialog/file-upload-dialog.component';
import { FileUploadService } from 'app/main/file-upload/file-upload.service';
import { takeUntil, tap } from 'rxjs/operators';
import { DeleteCompanyDialogComponent } from './DeleteCompanyDialog/DeleteCompanyDialog.component';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
    companies$: Observable<CompanySubset[]>;
    loading$: Observable<boolean>;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        protected store: Store<AppState>,
        protected dialog: MatDialog,
        protected fileUploadService: FileUploadService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        this.loading$ = this.store.pipe(select(CompaniesSelectors.selectCompaniesLoading));

        // Companies
        this.companies$ = this.store
            .pipe(
                takeUntil(this._unsubscribeAll),
                select(CompaniesSelectors.selectAllCompaniesSorted)
            );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    importFile(company: CompanySubset): void {
        const dialogRef = this.dialog.open(FileUploadDialogComponent, {
            data: { company }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.refresh();
            }
        });
    }

    refresh(): void {
        this.store.dispatch(CompaniesActions.companiesRequested());
    }

    deleteOption(company: CompanySubset): void {
        const dialogRef = this.dialog.open(DeleteCompanyDialogComponent, {
            data: { company }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                // this.refresh();
                window.location.reload();
                
            }
        });
    }

}
